module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAATlBMVEUAAADWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDWFQDJlmSoAAAAGXRSTlMAvlXC9JnxK59dHgyxqzIxJtvNtrOFdmkYJ8s3wgAAAFxJREFUCNdVzFkOgCAMRdEqgyIqzvr2v1FfoMR4Ez4OTSsxtKItFx+g7pw9RAxd5GFEnTUOolblGmDy2KnSCn48Vekk76q5t9i4/6mJRp2y8v1AOqreF6aiOf33AmQiBWQMkM9mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/叉号@2x.png
// module id = aYg5
// module chunks = 0